import React from "react";

import { MoreIcon } from "@/assets/icons";
import { Popover } from "@/components/ui";

import { ActionButton } from "./ActionButton";

interface MoreActionsProps {
  renderContent: (close: () => void, isOpen: boolean) => React.ReactNode;
}
export const MoreActions = (props: MoreActionsProps) => {
  const { renderContent } = props;

  return (
    <Popover
      className="[&_.popover-content]:border [&_.popover-content]:border-border [&_.popover-content]:px-0 [&_.popover-content]:py-2 [&_.popover-content]:shadow-soft"
      placement="top-end"
      role="menu"
      openOnFocus={false}
      renderContent={renderContent}
      renderTrigger={() => (
        <ActionButton aria-label="More actions" title="More actions">
          <MoreIcon />
        </ActionButton>
      )}
    />
  );
};
